import CONFIG from '@/configs/config'
import { Get, Post } from '@/utils/RequestService'

var apiUrl = CONFIG.API_URL
var service = {
  getUserReferral: (data) => Post(`${apiUrl}users/aff-info`, data),
  buyPackage: (data) => Post(`${apiUrl}users/buy`, data),
  getCommissionRefHistory: (symbol, page) => Get(`${apiUrl}coms/ref-history/${symbol}/${page}/20`),
  getCommissionAleoHistory: (page) => Get(`${apiUrl}coms/mining-history/${page}/20`),
  getCommissionBrandHistory: (symbol, page) => Get(`${apiUrl}coms/brand-history/${symbol}/${page}/20`),
  getCommissionIronHistory: (page) => Get(`${apiUrl}coms/iron-history/${page}/20`),
  getCommissionEstimation: () => Get(`${apiUrl}coms/estimate`),
  getMiningToken: () => Get(`${apiUrl}coms/mining-token`),
  convertToGh: (params) => Post(`${apiUrl}users/convert-mining`, params),
  getConvertHistory: (params) => Get(`${apiUrl}users/convert-history/${params.packageId}`)
}

export default service
